import { Route, Redirect } from 'react-router'
import React from 'react'
import App from './app'
import Checkout from './checkout'
import Pricing from './pricing'
import Report from './report'
import Tools from './tools'

// we have to pass the store into this function so we can extract user name from cookies
export default function getRoutes(store) {
  const AppWrapper = (props) => {
    return (
      <App
        userName={store.getState().me.user_name}
        {...props}
      />
    )
  }

  return [
    <Route path='/' component={AppWrapper} />,
    <Route path='/login' getComponent={(location, cb) => {
      import('./login').then(C => {
        cb(null, C.default)
      })
    }} />,
    <Route path='/signup' getComponent={(location, cb) => {
      import('./signup').then(C => {
        cb(null, C.default)
      })
    }} />,
    <Route path='/recover' getComponent={(location, cb) => {
      import('./recover').then(C => {
        cb(null, C.default)
      })
    }} />,
    <Redirect from="/upgrade" to={'/checkout'} />,
    <Route path='/checkout' getComponent={(location, cb) => {
      cb(null, Checkout)
    }} />,
    <Route path='/pricing' getComponent={(location, cb) => {
      cb(null, Pricing)
    }} />,
    <Route path='/report/(:shortcode)' getComponent={(location, cb) => {
      cb(null, Report)
    }} />,
    <Route path='/clipper' getComponent={(location, cb) => {
      import('./clipper').then(C => {
        cb(null, C.default)
      })
    }} />,
    <Route path='/clipper/*' getComponent={(location, cb) => {
      import('./clipper').then(C => {
        cb(null, C.default)
      })
    }} />,
    <Route path='/edit/(:shortcode)' getComponent={(location, cb) => {
      import('./editor').then(C => {
        cb(null, C.default)
      })
    }} />,
    <Route path='/thumbnail/(:shortcode)' getComponent={(location, cb) => {
      import('./thumbnail').then(C => {
        cb(null, C.default)
      })
    }} />,
    <Route path='/trim-video' component={Tools}/>,
    <Route path='/rotate-video' component={Tools}/>,
    <Route path='/mute-video' component={Tools}/>,
    <Route path='/compress-video' component={Tools}/>,
    <Route path='/embed-video' component={Tools}/>,
    <Route path='/crop-video' component={Tools}/>,
    <Route path='/upload-video' component={Tools}/>,
    <Route path='/(:view)' component={App} />,
    <Route path='/(:view)/(:shortcode)' component={App} />,
    <Route path='/(:view)/(:shortcode)/(:version)' component={App} />
  ]
}
